import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";

// Pages
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Login from "./pages/Login";
import { Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import GovernanceReview from "./pages/GovernanceReview";
import HealthCheck from "./pages/HealthCheck";
import Leads from "./pages/Leads";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/signup" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/health-check" element={<HealthCheck />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="governance-review" element={<GovernanceReview />} />
              <Route path="leads" element={<Leads />} />
              {/* Legacy 4-phase routes now fold into the unified governance review */}
              <Route path="methodology" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="phase-1" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="phase-2" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="phase-3" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="phase-4" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="improvement-plan" element={<Navigate to="/dashboard/governance-review" replace />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
